(function(guide, $, undefined)
{
	var $_inventoryContainer;

    guide.init = function()
    {
        this.cacheInitialized = [];
        this.sections = {
            'index' : 'uiIndex',
            'ninja-page' : 'uiCodexNinjaPage',
            'ninjas-list' : 'uiCodexNinjasList',
	        'genjutsus-socketed' : 'uiCodexGenjutsusSocketed'
        };

        main.loadPageEvents(jsData['subPage']);

        this.uiEvents();

        main.setStartingPushState();
    };

    guide.uiEvents = function()
    {
        // smooth scrolling when clicking hash link
        $('a[href^=#]').on('click', function(e)
        {
            e.preventDefault();

            $('html,body').animate({
	            scrollTop: $(this.hash)[0].offsetTop + 450
            }, 500);
        });
    };

    guide.uiIndex = function()
    {

    };

	guide.uiCodexNinjaPage = function()
	{
		main.displayNinjaGraphs($('#ninjaStatsGraph'), {
			animation: false
		});
	};

    guide.uiCodexNinjasList = function()
    {
        main.displayNinjaGraphs($('.c-ninja-graph canvas'), {
        	animation: false
        });

	    main.setPreselectedListFilters('ninjas-filter', '#ninjas-list .c-box', {
		    'Multiple' : true
	    });

        if ('ninjas-list' in this.cacheInitialized)
            return true;

        this.cacheInitialized['ninjas-list'] = true;

        main.$_centercol.on('click', '#ninjas-sort .c-filter-button', clickSortButton);
        main.$_centercol.on('click', '#ninjas-filter .c-filter-button', clickFilterButton);
	    main.$_centercol.on('mouseover', '#ninjas-list .c-rank', main.showTooltipRanks);


        function clickSortButton()
        {
            var $this = $(this),
                sort = $this.data('sort'),
                selector = {};

            $this.addClass('-c-sel').siblings().removeClass('-c-sel');

            if (sort == 'chakra')
                selector = { selector: '.c-card__chakra span', attr: null };
            else if (sort == 'cost')
                selector = { selector: '.c-resource.-resource-gold span', attr: null };
            else if (sort == 'name')
                selector = { selector: '.c-ninja-box-info__name', attr: null, order: 'asc'};
            else if (sort == 'stats')
	            selector = { selector: '.js-stat-stats', attr: 'data-pow' };
            else if (sort == 'tai')
                selector = { selector: '.-stat-tai' };
            else if (sort == 'nin')
                selector = { selector: '.-stat-nin' };
            else if (sort == 'buki')
                selector = { selector: '.-stat-buki' };
            else if (sort == 'sta')
	            selector = { selector: '.-stat-sta' };
            else if (sort == 'ele')
                selector = { selector: '.-stat-ele' };
            else if (sort == 'gen')
                selector = { selector: '.-stat-gen' };

            // place missing last
            selector = $.extend(true, {
	            place: 'start',
	            attr: 'data-worth',
	            order: 'desc'
            }, selector);

            tinysort(main.$_centercol.find('#ninjas-list .c-box'), selector);
        }

	    function clickFilterButton()
	    {
		    $(this).setFilterButtonSelection();

		    main.filterList('ninjas-filter', '#ninjas-list .c-box', {
			    'Multiple' : true
		    });
	    }
    };

	guide.uiCodexGenjutsusSocketed = function()
	{
		main.setPreselectedListFilters('inventory-filter', '#inventory-list .c-inventory-box', {
			'Multiple' : true
		});

		// cache
		this.$_inventoryContainer = main.$_centercol.find('#inventory-list');

		main.$_centercol.on('click', '#inventory-sort .c-filter-button', clickSortButton);


		function clickSortButton()
		{
			var $this = $(this),
				sort = $this.data('sort'),
				selector = {};

			$this.addClass('-c-sel').siblings().removeClass('-c-sel');

			if (sort === 'name')
				selector = { selector: '.c-inventory-box__item .c-item__name', order: 'asc' };
			else if (sort === 'capacity')
				selector = { data: 'capacity', order: 'asc' };

			// place missing last
			selector = $.extend(true, {
				place: 'start',
				order: 'desc'
			}, selector);

			tinysort(guide.$_inventoryContainer.find('.c-inventory-box'), selector);
		}
	};

}(window.guide = window.guide || {}, jQuery));

$(function()
{
    guide.init();
});
